import { render, staticRenderFns } from "./behaviorAnalysis.vue?vue&type=template&id=5006059c&scoped=true&"
import script from "./behaviorAnalysis.vue?vue&type=script&lang=js&"
export * from "./behaviorAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./behaviorAnalysis.vue?vue&type=style&index=0&id=5006059c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006059c",
  null
  
)

export default component.exports